/**
 * `metadata-import` customer-portal config — the per-interface constants for the Metadata Import &
 * Enrichment product. Mirrors `spotter/config.ts`'s role (wordmark + nav defs kept out of JSX so a
 * later round can repoint them / promote them to plugin variables without hunting through
 * component files). NOTHING NFL-specific here — this is the generic reusable capability.
 *
 * SPIKE: frontend-only over mocked data.
 */

/** Header wordmark + single source of truth for the product name in copy. */
export const MI_WORDMARK = "Metadata Import";

/** The base route this interface mounts at (see `AppRouter.tsx`). */
export const MI_BASE = "/metadata-import";

/** The `requirePlugin(interfaceId)` string `apps/customer-api/src/routes/index.ts` gates every
 *  `/api/metadata-import/*` route with, and the same id `GET /api/context`'s `enabledInterfaces`
 *  carries — MUST stay in sync (no shared package between the two apps to import it from). Feeds
 *  `useInterfaceAccess`, the single "is this org actually entitled to Metadata Import" check
 *  `OverviewScreen`/`ProfileScreen` use. */
export const MI_INTERFACE_ID = "metadata-import";

export type WorkflowMode = "collection-sync" | "asset-import";

export const WORKFLOW_LABEL: Record<WorkflowMode, string> = {
  "collection-sync": "Collection Sync",
  "asset-import": "Asset Import",
};

export type SourceFormat = "csv" | "xlsx";

export const FORMAT_LABEL: Record<SourceFormat, string> = {
  csv: "CSV",
  xlsx: "XLSX",
};

export type Strategy = "append" | "overwrite" | "rewrite";

export const STRATEGY_LABEL: Record<Strategy, string> = {
  append: "Append",
  overwrite: "Overwrite",
  rewrite: "Rewrite",
};

export type ProfileStatus = "active" | "draft" | "paused" | "error";

export const STATUS_LABEL: Record<ProfileStatus, string> = {
  active: "Active",
  draft: "Draft",
  paused: "Paused",
  error: "Needs attention",
};
